"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KetteLengthCalcInitializedBy = void 0;
/**
 * The `KetteLengthCalcInitializedBy` defines the way the Kette objects length calculations have
 * been initialized.
 */
var KetteLengthCalcInitializedBy;
(function (KetteLengthCalcInitializedBy) {
    KetteLengthCalcInitializedBy["laenge"] = "laenge";
    KetteLengthCalcInitializedBy["verfahrweg"] = "verfahrweg";
    KetteLengthCalcInitializedBy["numGlieder"] = "numGlieder";
})(KetteLengthCalcInitializedBy = exports.KetteLengthCalcInitializedBy || (exports.KetteLengthCalcInitializedBy = {}));
//# sourceMappingURL=KetteLengthCalcInitializedBy.js.map